import { VFlow } from 'bold-ui'
import React from 'react'

import { NewsHeadingSection } from '../components/NewsHeadingSection'
import { NewsListItem } from '../components/NewsListItem'

export function NewsInternalEstabilizacaoV54() {
  return (
    <VFlow>
      <NewsHeadingSection title='Versão 5.4.22' id='estabilizacao-5-4-22'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Correção de problema em que a importação do CNES resultava em falha em algumas situações.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde a lista temática de gestação e puerpério apresentava erro em algumas unidades de
            saúde, no módulo de Acompanhamento de condições de saúde.
          </NewsListItem>
          <NewsListItem>
            Ajustes nas impressões dos relatórios de Cadastro individual, para que a linha de totais das colunas
            Masculino, Feminino e Total exiba corretamente o último caractere dos valores.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.4.21' id='estabilizacao-5-4-21'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Inclusão do procedimento SIGTAP "02.14.01.030-9 - Teste rápido para detecção de anticorpos contra o vírus da
            hepatite C em gestante" nas listas temáticas de gestação/puerpério e saúde da mulher do Acompanhamento de
            condições de saúde.
          </NewsListItem>
          <NewsListItem>
            Inclusão de campos referentes ao programa Bolsa Família nas listas temáticas do Acompanhamento de condições
            de saúde.
          </NewsListItem>
          <NewsListItem>
            Melhoria na usabilidade da lista do módulo de Cuidado compartilhado, mantendo os filtros e a paginação ao
            navegar em outras telas do sistema.
          </NewsListItem>
          <NewsListItem>
            Remoção de obrigatoriedade de adição de problemas/condições de diabetes e hipertensão a partir do histórico
            para profissionais de nível superior, exceto médicos e enfermeiros.
          </NewsListItem>
          <NewsListItem>
            Implementada a validação para que o registro de aplicação de imunobiológicos seja feito apenas com
            fabricantes padronizados, impedindo o registro manual por meio da transcrição de caderneta do PEC.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde o exame de hemoglobina glicada não era exibido na lista temática de diabetes no
            módulo de Acompanhamento de condições de saúde.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde o botão de fechar não era apresentado ao gerar atestado digital.
          </NewsListItem>
          <NewsListItem>
            Correção da sobreposição do texto "Registro tardio realizado em" que estava sendo exibido em cima da linha
            divisória nas impressões do Histórico clínico do cidadão.
          </NewsListItem>
          <NewsListItem>
            Correção de erro na impressão de encaminhamentos de serviço especializado, que impedia a exibição completa
            de alguns títulos.
          </NewsListItem>
          <NewsListItem>
            Inclusão de opção para gerar documento de autorização para retirada de absorventes do Programa de Dignidade
            Menstrual.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.4.19' id='estabilizacao-5-4-19'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Correção de erro ao adicionar resultados de exames, onde não estava sendo possível realizar a adição do
            resultado e era exibida, indevidamente, a mensagem: "A data de realização do exame não está de acordo com a
            idade do cidadão exigida para este procedimento".
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.4.18' id='estabilizacao-5-4-18'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Correção de erro que impedia o download de relatórios em formato CSV por meio da funcionalidade "Ver
            relatórios recentes". A atualização também resolve o problema que impactava os relatórios da RNDS.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde não estava sendo possível realizar a atualização do sistema em algumas instalações.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.4.17' id='estabilizacao-5-4-17'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Evolução do cadastro de imóvel e famílias para permitir informar a opção "mudou-se" para a família e o
            responsável familiar, simultaneamente.
          </NewsListItem>
          <NewsListItem>Adaptações no gráfico de IMC para gestantes com até 48 semanas de gestação.</NewsListItem>
          <NewsListItem>
            Atualização no módulo de profissionais para exibir o rótulo "Não vinculada ao CNES" para lotações do tipo
            "estagiário" cadastradas manualmente.
          </NewsListItem>
          <NewsListItem>
            Implementada a validação para que os registros de aplicações de imunobiológicos sejam feitos apenas com
            fabricantes padronizados, impedindo a criação manual por meio de registros de vacinação realizados no CDS ou
            por meio de recebimentos do modelo de informação de vacinação.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde, após realizar a unificação de cadastros, todas as atividades coletivas previamente
            registradas não estavam sendo exibidas no histórico clínico destes cidadãos.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.4.15' id='estabilizacao-5-4-15'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Ampliação da base de fabricantes, atualização das denominações de imunobiológicos e revisão das regras de
            vacinação aplicadas pelo sistema.
          </NewsListItem>
          <NewsListItem>
            Atualização da tabela SIGTAP conforme a competência de 08/2025, com inclusões e alterações em procedimentos
            e CID10.
          </NewsListItem>
          <NewsListItem>
            Inclusão de visualização dos filtros aplicados acima da tabela no módulo de Acompanhamento de condições de
            saúde.
          </NewsListItem>
          <NewsListItem>
            Atualização na descrição do instrumento IVCF-20, bem como ajustes nos comportamentos e relação entre as
            perguntas referentes ao grupo de cognição.
          </NewsListItem>
          <NewsListItem>
            Melhorias na gestão de Grupos de exames para que o sistema exiba alertas e identificações visuais para
            grupos que contêm exames inativos, garantindo que o administrador possa manter as listas atualizadas e
            evitar inconsistências durante os atendimentos.
          </NewsListItem>
          <NewsListItem>
            Inclusão de data, hora e local do atendimento na impressão das orientações encaminhadas ao cidadão durante
            um atendimento.
          </NewsListItem>
          <NewsListItem>
            Melhoria no fluxo de impressão da prescrição, mantendo a tela de "Encaminhar prescrição" aberta após
            realizar uma impressão.
          </NewsListItem>
          <NewsListItem>
            Correção no comportamento do filtro "Ver somente os lembretes criados por mim" do componente de Lembretes
            presente na Folha de rosto e na Lateral do atendimento.
          </NewsListItem>
          <NewsListItem>
            Correção de problema onde o formulário de prescrição de medicamentos era apagado ao excluir algum
            medicamento previamente adicionado.
          </NewsListItem>
          <NewsListItem>
            Correção na impressão da solicitação de exames que exibia o termo "null" incorretamente no campo CID-10
            quando este não era informado. Agora, o campo exibirá o texto "Não informado" para estes cenários.
          </NewsListItem>
          <NewsListItem>
            Correção de erro em que as notificações do Cuidado compartilhado não eram atualizadas corretamente após a
            troca de lotação pelo profissional.
          </NewsListItem>
          <NewsListItem>
            Correções e melhorias visando performance durante as etapas de processamento de Atividades coletivas,
            Cadastros domiciliares e Equipes vinculadas nos relatórios.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.4.14' id='estabilizacao-5-4-14'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Correção de problema onde não estava sendo possível realizar a impressão de relatórios de atendimentos
            individuais e odontológicos devido a uma falha no número máximo de grupos de informação selecionados.
          </NewsListItem>
          <NewsListItem>
            Correções e melhorias visando performance durante a etapa de processamento de famílias, procedimentos e
            cidadãos nos relatórios.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde não estava sendo possível remover cidadãos da Lista de atendimentos em algumas
            instalações.
          </NewsListItem>
          <NewsListItem>
            Correção na impressão da caderneta de vacinação, onde em alguns casos, estava sendo impressa a palavra
            "null" incorretamente.
          </NewsListItem>
          <NewsListItem>
            Correção no atendimento individual/puericultura, onde ao incluir antecedentes, marcar no plano como "em
            observação", finalizar e gerar lote, o sistema apresentava o erro 136 e não transmitia os dados.
          </NewsListItem>
          <NewsListItem>
            Correção na Solicitação de exames/procedimentos em atendimentos de observação para impedir a exclusão de
            solicitações do atendimento anterior.
          </NewsListItem>
          <NewsListItem>
            Correção do problema que gerava erroneamente a inconsistência de "Responsável em outro domicílio", no módulo
            de Acompanhamento do território.
          </NewsListItem>
          <NewsListItem>
            Correção no resultado do exame da Prova do Laço, que passa a exibir corretamente o resultado registrado no
            atendimento que deu início ao atendimento de observação.
          </NewsListItem>
          <NewsListItem>
            Correção de problema que impedia a finalização de alguns atendimentos de vacinação.
          </NewsListItem>
          <NewsListItem>Correção de problema que impedia que a videochamada ocorresse normalmente.</NewsListItem>
          <NewsListItem>
            Ajustes realizados no módulo Garantia de acesso, incluindo a reorganização do campo "Número de tentativas de
            contato" na remoção da lista, melhoria na orientação de busca de cidadãos e a padronização de textos e
            alertas para maior clareza.
          </NewsListItem>
          <NewsListItem>
            Implementação da auditoria no campo "Desfecho da última gestação" do módulo de antecedentes.
          </NewsListItem>
          <NewsListItem>
            Criação de auditoria de evento de deleção de uma lotação para que todas as exclusões de lotações sejam
            registradas, garantindo rastreabilidade e maior segurança nas operações do sistema.
          </NewsListItem>
          <NewsListItem>
            Alteração no gráfico de ganho de peso gestacional para que a idade gestacional seja arredondada conforme a
            quantidade de dias.
          </NewsListItem>
          <NewsListItem>
            Inclusão dos dados das vacinas, presentes em algumas listas temáticas, na exportação do CSV no
            Acompanhamento de condições de saúde.
          </NewsListItem>
          <NewsListItem>
            Alteração no comportamento dos novos campos do Atendimento de vacinação: "Motivo da prescrição" e
            "Profissional prescritor". Ambos os campos só podem ser preenchidos caso a vacina aplicada possua o campo
            "Estratégia" preenchido com o valor "Especial".
          </NewsListItem>
          <NewsListItem>Atualização dos nomes dos fabricantes relacionados aos imunobiológicos.</NewsListItem>
          <NewsListItem>
            Atualização nas regras de vacinação, nomenclatura e siglas dos imunobiológicos: "Nirsevimabe 0,5ml" e
            "Nirsevimabe 1,0ml".
          </NewsListItem>
          <NewsListItem>
            Inclusão dos campos "via de administração" e "local de aplicação" na Ficha de vacinação.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.4.13' id='estabilizacao-5-4-13'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Correção dos filtros do Relatório consolidado de Cadastro Individual para disponibilização da lista completa
            de etnias indígenas.
          </NewsListItem>
          <NewsListItem>
            Correção do cenário onde algumas pessoas em domicílios eram apresentadas sem microárea nos Acompanhamentos.
          </NewsListItem>
          <NewsListItem>
            Correção do cenário onde não era possível gerar o relatório gerencial de vacinação caso não houvesse
            estratégia e dose preenchidas em alguma vacinação.
          </NewsListItem>
          <NewsListItem>
            Correção na Discussão de caso do Cuidado Compartilhado, onde o texto preenchido no campo "Observação" não
            era salvo no histórico ao agendar uma consulta entre profissionais.
          </NewsListItem>
          <NewsListItem>
            Correção no agendamento através do módulo Garantia de Acesso, que permitia agendar uma consulta para um
            cidadão já atendido no mesmo dia, sem exibir o alerta de confirmação necessário.
          </NewsListItem>
          <NewsListItem>
            Correção no Cuidado Compartilhado, onde em algumas situações a notificação não era marcada como lida após
            visualização pelo profissional.
          </NewsListItem>
          <NewsListItem>
            Correção na aba "Encaminhamentos": ao criar um novo encaminhamento durante um atendimento, os campos "Motivo
            do encaminhamento" e "Observações" não eram limpos após o salvamento, permanecendo com dados do registro
            anterior.
          </NewsListItem>
          <NewsListItem>
            Ajustes nas vacinas consideradas para o campo Difteria, Tétano, Pertusis, Hepatite B, Haemophilus Influenza
            B na lista temática de desenvolvimento infantil.
          </NewsListItem>
          <NewsListItem>Inclusão de novos fabricantes no PEC para cadastro do lote de imunobiológico.</NewsListItem>
          <NewsListItem>
            Inclusão do indicador "Problema/condição não incluído na lista de problemas e condições" na tabela da lista
            temática de Hipertensão e Diabetes.
          </NewsListItem>
          <NewsListItem>
            Inclusão de "Saiba mais" no Acompanhamento de condições de saúde, explicando a origem de cada uma das
            informações exibidas nas listagens.
          </NewsListItem>
          <NewsListItem>Inclusão do campo "Há mais de 10 anos" no desfecho da última gestação.</NewsListItem>
          <NewsListItem>
            Adaptação do Histórico Clínico e dos relatórios de produção de atendimento individual e odontológico para
            exibição de Ofertas de Cuidados Integrados (OCI).
          </NewsListItem>
          <NewsListItem>
            Atualização na exibição de dados de IMC e Peso durante a gestação, onde o sistema passa a exibir apenas o
            IMC Pré-Gestacional no período da gestação.
          </NewsListItem>
          <NewsListItem>
            No gráfico de peso, o sistema deixa de apresentar o peso informado durante a gestação, já que esse
            acompanhamento deve ser feito exclusivamente pelo gráfico de ganho de peso gestacional.
          </NewsListItem>
          <NewsListItem>
            Ajuste para impedir a solicitação duplicada de OCI dentro de um mesmo atendimento.
          </NewsListItem>
          <NewsListItem>
            Revisão e atualização do tópico 3 dos termos de consentimento para videochamada no PEC, contemplando tanto a
            versão apresentada ao cidadão quanto a versão apresentada ao profissional de saúde.
          </NewsListItem>
          <NewsListItem>Inclusão de novos medicamentos disponíveis para prescrição.</NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.4.11' id='estabilizacao-5-4-11'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Correção de cenários em que uma tela branca ou erro inesperado era apresentado ao usuário.
          </NewsListItem>
          <NewsListItem>
            Otimização e correção na performance do sistema para evitar uso desnecessário de memória que causava
            lentidão em algumas instalações.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.4.10' id='estabilizacao-5-4-10'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Inclusão do filtro "Não incluídos na lista de problemas e condições" no módulo de Acompanhamento de
            condições de saúde.
          </NewsListItem>
          <NewsListItem>
            Remoção da geração de relatórios operacionais através do Acompanhamento de condições de saúde.
          </NewsListItem>
          <NewsListItem>
            Desativação da impressão de atendimentos de Visita domiciliar e territorial para os casos de visita recusada
            ou cidadão ausente no Histórico clínico.
          </NewsListItem>
          <NewsListItem>
            Alteração da nomenclatura do módulo "Acompanhamento de vacinação" para "Busca ativa de vacinação".
          </NewsListItem>
          <NewsListItem>
            Atualização da regra para o registro da aplicação dos imunobiológicos "Nirsevimabe 50mg", "Nirsevimabe
            100mg" e "Vacina pneumo 23".
          </NewsListItem>
          <NewsListItem>
            Inclusão do fabricante de imunobiológico "Glaxosmithkline Biologicals S.A. - Franca".
          </NewsListItem>
          <NewsListItem>
            Atualização da regra de fabricante para o registro da aplicação do imunobiológico "COVID-19 PFIZER -
            COMIRNATY PEDIÁTRICA MENOR DE 5 ANOS".
          </NewsListItem>
          <NewsListItem>
            Inclusão de data da última atualização dos Marcadores de consumo alimentar dentro do atendimento.
          </NewsListItem>
          <NewsListItem>
            Atualização na exibição do IMC para gestantes: agora o IMC pré-gestacional é exibido no componente de
            medições na lateral do atendimento.
          </NewsListItem>
          <NewsListItem>
            Padronização dos resultados de exames quantitativos para duas casas decimais nos exames de Colesterol total,
            HDL, LDL, Dosagem de triglicerídeos e Creatinina, garantindo maior precisão dos valores.
          </NewsListItem>
          <NewsListItem>
            Melhoria na aparência dos botões da Puericultura e do M-CHAT-R, foram realizados ajustes visuais nos botões
            dessas seções para padronizar os estados de pairar e pressionado.
          </NewsListItem>
          <NewsListItem>
            Em instalações de treinamento, será adicionada a marca d’água “INVÁLIDO” nos documentos impressos para
            indicar que não têm validade legal. A medida vale para: Guia de encaminhamento, Solicitação de exames,
            Prescrição de medicamentos, Declaração de comparecimento e Atestados.
          </NewsListItem>
          <NewsListItem>
            Correção de erro que era apresentado no histórico ao visualizar atendimentos com prescrição que foram
            reprocessados.
          </NewsListItem>
          <NewsListItem>
            Correção de erro onde uma tela branca era apresentada ao atender cidadão em observação com prescrição prévia
            de medicamento Celecoxibe.
          </NewsListItem>
          <NewsListItem>
            Melhoria no campo "Usuário" para permitir o uso da pontuação do CPF durante o acesso ao sistema.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que ocorria erro na unificação de bases devido à Lista de problemas/condições.
          </NewsListItem>
          <NewsListItem>
            Correção de erro ao utilizar a lista temática de gestação e puerpério no Acompanhamento de condições de
            saúde quando não havia DUM preenchida.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.4.9' id='estabilizacao-5-4-9'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Remodelagem dos filtros das listas temáticas no módulo de Acompanhamento de condições de saúde, visando
            facilitar a usabilidade das temáticas específicas.
          </NewsListItem>
          <NewsListItem>Inclusão do filtro e campos de raça/cor no Acompanhamento de condições de saúde.</NewsListItem>
          <NewsListItem>
            Inclusão de dados de vacinação nas listas temáticas de desenvolvimento infantil, gestação e puerpério, saúde
            da mulher e pessoa idosa.
          </NewsListItem>
          <NewsListItem>
            Inclusão de dicas informando quais códigos SIGTAP/CIAP são considerados para preencher o valor de alguns dos
            campos no Acompanhamento de condições de saúde.
          </NewsListItem>
          <NewsListItem>
            Incluída funcionalidade para evitar sobrecarga do sistema ao utilizar o módulo de Acompanhamento de
            condições de saúde, que cancela a busca caso ela demore mais que 5 minutos. Esta função é parametrizável
            através de contato com o suporte.
          </NewsListItem>
          <NewsListItem>
            Alteração para incluir o teste rápido de HBV no campo Hepatite B da lista temática de gestação e puerpério e
            saúde da mulher no Acompanhamento de condições de saúde.
          </NewsListItem>
          <NewsListItem>
            Migração do módulo Busca ativa de vacinação ao menu de Acompanhamentos. Ele passará a se chamar
            Acompanhamento de vacinação.
          </NewsListItem>
          <NewsListItem>
            Inclusão de campo referente à idade gestacional calculada pela DUM (antigo idade gestacional cronológica)
            durante o primeiro atendimento individual com pré-natal.
          </NewsListItem>
          <NewsListItem>
            Cuidados compartilhados agora são automaticamente finalizados por óbito quando o cidadão é marcado como
            falecido. Para cuidados com situação Aguardando, apenas a conduta de recondução de cuidado é permitida.
          </NewsListItem>
          <NewsListItem>
            Registros na Garantia do acesso agora possuem um indicador visual quando o cidadão está falecido. Nesses
            casos, o agendamento e a edição são desabilitados, e é permitida apenas a remoção com o motivo: Óbito do
            cidadão.
          </NewsListItem>
          <NewsListItem>
            Foi alterada a nomenclatura da funcionalidade Unificação de cadastros para Unificação de prontuários, com o
            objetivo de sensibilizar melhor os usuários sobre o impacto da ação.
          </NewsListItem>
          <NewsListItem>
            Correção de erro ao finalizar o atendimento quando realizava o encerramento do pré-natal.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde é possível salvar uma prescrição sem o campo "Tipo de dose" estar preenchido.
          </NewsListItem>
          <NewsListItem>
            Remoção de mensagem incorreta ao salvar a edição de um medicamento de uma prescrição.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.4.8' id='estabilizacao-5-4-8'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Correção de erro relacionado à importação da data de nascimento dos profissionais via CNES.
          </NewsListItem>
          <NewsListItem>
            Correção de erro ao realizar a impressão de registros de Visita domiciliar e territorial com origem no MICI
            no Histórico clínico do cidadão.
          </NewsListItem>
          <NewsListItem>
            Correção de erro onde não estava sendo possível realizar a seleção de cidadão no Registro tardio de
            atendimento.
          </NewsListItem>
          <NewsListItem>
            Correção de erro ao registrar a aplicação de um mesmo imunobiológico, mesma dose e com estratégia diferente
            no Atendimento de vacinação.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde um alerta era apresentado indevidamente ao tentar finalizar um atendimento,
            indicando inconsistência nos procedimentos.
          </NewsListItem>
          <NewsListItem>
            Correção de erro onde uma tela branca era apresentada ao tentar visualizar um Atendimento domiciliar no
            Histórico clínico do cidadão.
          </NewsListItem>
          <NewsListItem>
            Correção nos filtros do módulo de Acompanhamento de condições de saúde, onde cidadãos que estavam em risco
            de insegurança alimentar não eram apresentados corretamente.
          </NewsListItem>
          <NewsListItem>
            Correção de erro onde a reterritorialização de domicílio era impedida caso o cidadão já não residisse mais
            no local.
          </NewsListItem>
          <NewsListItem>
            Realizados ajustes no indicador de atualização em tempo real, que não estava funcionando corretamente, no
            campo data provável do parto ecográfica no Atendimento de pré-natal.
          </NewsListItem>
          <NewsListItem>
            Correção de erro no processamento de relatórios na etapa "Higienização do Fato Cidadão do PEC" que acontecia
            em algumas instalações.
          </NewsListItem>
          <NewsListItem>Atualização das regras para o registro da aplicação de diversos imunobiológicos.</NewsListItem>
        </VFlow>
      </NewsHeadingSection>
    </VFlow>
  )
}
